import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["isChecked", "type", "iserror", "onCheckboxChange", "testId"];
globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _styled from "styled-components";
import { useTranslation } from 'next-i18next';
import { Checkbox } from '../../design-system';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export var TermsAndConditions = function TermsAndConditions(_ref) {
  var isChecked = _ref.isChecked,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'default' : _ref$type,
      iserror = _ref.iserror,
      onCheckboxChange = _ref.onCheckboxChange,
      testId = _ref.testId,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsx(Checkbox, _objectSpread({
    id: "terms-and-conditions-".concat(type),
    variant: "box",
    iserror: iserror,
    title: /*#__PURE__*/_jsxs(TitleWrapper, {
      iserror: iserror,
      children: [/*#__PURE__*/_jsxs("span", {
        children: [t('common:terms_and_conditions.i_have_read_and_accepted_the'), " "]
      }), /*#__PURE__*/_jsx(CustomLink, {
        href: "http://www.restworld.it/condizioni_worker_04.07.2022.pdf",
        target: "_blank",
        rel: "noopener noreferrer",
        iserror: iserror,
        children: t('common:terms_and_conditions.terms_and_conditions_of_the_service')
      }), /*#__PURE__*/_jsx("span", {
        children: " e la "
      }), /*#__PURE__*/_jsx(CustomLink, {
        href: "https://www.restworld.it/privacy-policy",
        target: "_blank",
        rel: "noopener noreferrer",
        iserror: iserror,
        children: "privacy policy"
      })]
    }),
    isChecked: isChecked,
    mode: "clickable",
    onChange: onCheckboxChange,
    testId: testId
  }, rest));
};
export var TitleWrapper = /*#__PURE__*/_styled.p.withConfig({
  displayName: "terms-and-conditions__TitleWrapper",
  componentId: "sc-qpqf6y-0"
})(["", " ", ""], {
  "display": "inline-block",
  "width": "100%",
  "fontSize": "0.875rem",
  "lineHeight": "1.5rem",
  "fontWeight": "300",
  "--tw-text-opacity": "1",
  "color": "rgb(107 114 128 / var(--tw-text-opacity))"
}, function (_ref2) {
  var iserror = _ref2.iserror;
  return iserror ? {
    "--tw-text-opacity": "1",
    "color": "rgb(204 0 34 / var(--tw-text-opacity))"
  } : {};
});
export var CustomLink = /*#__PURE__*/_styled.a.withConfig({
  displayName: "terms-and-conditions__CustomLink",
  componentId: "sc-qpqf6y-1"
})(["", ""], function (_ref3) {
  var iserror = _ref3.iserror;
  return !iserror ? {
    "textDecorationLine": "underline",
    "textUnderlineOffset": "4px"
  } : {};
});